import { Heading } from '@iziwork/design-system';
import React from 'react';
import styled from 'styled-components';

const RoundLogo = styled.img`
  border-radius: 50%;
  max-width: 80px;
  margin: 0 1rem;
  @media (min-width: ${({ theme }) => theme.devices.tablet.min}) {
    max-width: 105px;
  }
`;

const ErrorWrapper = styled(Heading)`
  font-size: 8rem;
  font-weight: 700;
  margin-top: 2rem;
  margin-bottom: 5rem;
  @media (min-width: ${({ theme }) => theme.devices.tablet.min}) {
    font-size: 10.5rem;
  }
`;

interface ErrorLogoProps {
  prefix: string;
  suffix: string;
}

export const ErrorLogo = ({ prefix, suffix }: ErrorLogoProps) => (
  <ErrorWrapper variant="heading-1">
    {prefix}
    <span>
      <RoundLogo src="/images/brand-logo-no-text.svg" alt="0" />
    </span>
    {suffix}
  </ErrorWrapper>
);
